import { render, staticRenderFns } from "./shop-banner.vue?vue&type=template&id=1f78247c&scoped=true&"
import script from "./shop-banner.vue?vue&type=script&lang=js&"
export * from "./shop-banner.vue?vue&type=script&lang=js&"
import style0 from "./shop-banner.vue?vue&type=style&index=0&id=1f78247c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f78247c",
  null
  
)

export default component.exports